import { OnlyValueContainer, OnlyValueText } from './styles';

interface IProps {
  value: string;
}

const OnlyValue = ({ value }: IProps) => {
  return (
    <OnlyValueContainer>
      <OnlyValueText>{value}</OnlyValueText>
    </OnlyValueContainer>
  );
};

export default OnlyValue;
